var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('OrdersList',{attrs:{"orders-type":_vm.$route.params.type}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }